<template>
    <app-layout>
        <Head>
            <title>Bauteil</title>
        </Head>

        <template v-slot:intronav>
            <div class="row">
                <div class="col col-4">
                    <form-button icon="cursor-swipe-left" color="primary" dense="true" @click="stepBack" :disabled="isFirst"/>
                    <form-button icon="cursor-swipe-up" color="primary" dense="true" @click="stepOverview"/>
                    <form-button icon="cursor-swipe-right" color="primary" dense="true" @click="stepNext" :disabled="isLast"/>
                </div>
            </div>
        </template>

        <div class="component">
            <div class="row">
                <div class="col col-4">
                    <div class="row">
                        <div class="col">
                            <component-sidebar-sketch :ask-for-quote="askForQuote"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <component-sidebar-inquiry :ask-for-quote="askForQuote"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <component-sidebar-proposals :ask-for-quote="askForQuote"/>
                        </div>
                    </div>
                </div>
                <div class="col col-8">
                    <div class="row">
                        <div class="col">
                            <card class="error" v-if="askForQuote.status === -1">
                                <card-content>
                                    <span class="subtitle-1"><translate>Ihre Anfrage wurde abgelehnt</translate></span>
                                </card-content>
                            </card>

                            <component-order :ask-for-quote="askForQuote" v-if="clientOrder"/>

                            <component-offer :ask-for-quote="askForQuote" v-if="clientOffers" :has-client-order="hasClientOrder" :client-offer-rejected="clientOfferRejected" :client-offer-invalid="clientOfferInvalid"/>

                            <component-alternate-offers :ask-for-quote="askForQuote" v-if="clientOffers && hasAlternateClientOffers" :has-client-order="hasClientOrder" />

                            <card v-if="!clientOffers">
                                <card-header>
                                    <card-title>
                                        <translate>Angebot</translate>
                                    </card-title>
                                </card-header>
                                <card-content>
                                    <translate>Es liegt noch kein Angebot vor</translate>
                                </card-content>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ComponentSidebarInquiry from '@partfactory/Pages/Client/Component/ComponentSidebarInquiry';
import ComponentSidebarProposals from '@partfactory/Pages/Client/Component/ComponentSidebarProposals';
import ComponentOffer from '@partfactory/Pages/Client/Component/ComponentOffers';
import ComponentAlternateOffers from '@partfactory/Pages/Client/Component/ComponentAlternateOffers';
import ComponentSidebarSketch from '@partfactory/Pages/Client/Component/ComponentSidebarSketch';
import ComponentOrder from '@partfactory/Pages/Client/Component/ComponentOrder';

export default {
    name: 'Component',
    components: {
        ComponentOrder,
        ComponentSidebarSketch,
        ComponentAlternateOffers,
        ComponentOffer,
        ComponentSidebarProposals,
        ComponentSidebarInquiry,
        FormButton,
        CardTitle,
        CardContent,
        CardHeader,
        Card,
        AppLayout
    },
    props: {
        askForQuote: Object,
    },
    computed: {
        clientOffers() {
            return !!this.askForQuote.client_offers.length;
        },
        hasAlternateClientOffers() {
            return this.askForQuote.bid_round_member_offers_count > 1;
        },
        clientOrder() {
            return this.askForQuote.client_order;
        },
        hasClientOrder() {
            return !!this.askForQuote.client_order;
        },
        clientOfferRejected() {
            return !!this.askForQuote.client_offers[0].rejected_at;
        },
        clientOfferInvalid() {
            const validDate = new Date(this.askForQuote.client_offers[0].offer_valid_date);
            const now = new Date(new Date().getFullYear() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate());

            return validDate.getTime() <= now.getTime() && !this.hasClientOrder;
        },
        isFirst() {
            return !! this.$page.props.errors.back;
        },
        isLast() {
            return !! this.$page.props.errors.next;
        },
    },
    methods: {
        stepBack() {
            this.$inertia.visit(this.$$route('component.back', {'askForQuote': this.askForQuote}));
        },
        stepNext() {
            this.$inertia.visit(this.$$route('component.next', {'askForQuote': this.askForQuote}));
        },
        stepOverview() {
            this.$inertia.visit(this.$$route('component.overview', {'askForQuote': this.askForQuote}));
        },
    }
};
</script>
